import React, { FC, useState, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import {
  ModalScrollableContainer,
  ModalScrollableHeader,
  ModalScrollableContent,
} from '../../../components/modal';
import { Hyperlink } from '../../../components/Hyperlink';
import styles from './commentary_decision_sources_modal.module.scss';
import {
  CommentaryDecisionSource,
  CommentarySourceType,
} from '../../commentary.types';
import { getCommentaryDecisionSourcesById } from '../../commentary.api';
import { doctrineAnalytics } from '../../../utils/analyticsUtils';

type Props = {
  commentaryId: string;
  isOpen: boolean;
  onRequestClose: () => void;
  source: string;
};

export const CommentaryDecisionSourcesModal: FC<Props> = ({
  commentaryId,
  isOpen,
  onRequestClose,
  source,
}) => {
  const [commentarySources, setCommentarySources] = useState<
    Array<CommentaryDecisionSource>
  >([]);

  useEffect(() => {
    async function fetchCommentarySources() {
      try {
        const { data } = await getCommentaryDecisionSourcesById(commentaryId);
        setCommentarySources(data);
      } catch (error) {
        throw error;
      }
    }
    fetchCommentarySources();
  }, [commentaryId]);

  const onSourceClicked = (
    commentarySource: CommentaryDecisionSource,
    index: number,
  ) => () => {
    doctrineAnalytics('Search ModalCommentarySourcesOpened', {
      commentaryId,
      sourceId: commentarySource.docId,
      source,
      position: index,
      type: CommentarySourceType.DECISION,
    });
  };

  return (
    <ModalScrollableContainer isOpen={isOpen} onRequestClose={onRequestClose}>
      <ModalScrollableHeader
        onClose={onRequestClose}
        title={
          <FormattedMessage
            id="commentary/CommentaryDecisionSourcesModal.tsx/1"
            values={{ count: commentarySources.length }}
          />
        }
      />
      <ModalScrollableContent>
        <ul className={styles.content}>
          {commentarySources.map((commentarySource, index) => (
            <li
              key={`commentary-source-${commentarySource.docId}`}
              className={styles.link}
            >
              <Hyperlink
                href={commentarySource.url}
                target="_blank"
                source={source}
                onClick={onSourceClicked(commentarySource, index)}
              >
                {commentarySource.title}
              </Hyperlink>
            </li>
          ))}
        </ul>
      </ModalScrollableContent>
    </ModalScrollableContainer>
  );
};
